import React from 'react';
import Spacing from '../../Spacing';
import { pageTitle } from '../../../helpers/PageTitle';
import { NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../../../context/AuthContext';

export default function Login() {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [isChecked, setIsChecked] = React.useState(false);
  const [data, setData] = React.useState({
    email: '',
    password: '',
  });
  const [error, setError] = React.useState('');
  const [loading, setLoading] = React.useState(false);

  async function submitForm(e) {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      await login(data.email, data.password);

      setData({
        email: '',
        password: '',
      });

      navigate('/');
    } catch (err) {
      setError(err.message || 'Login failed. Please check your credentials.');
      console.error(err);
    } finally {
      setLoading(false);
    }
  }

  pageTitle('Mobile App Development');
  return (
    <>
      <Spacing lg="70" md="70" />
      <Spacing lg="140" md="80" />
      <Spacing lg="75" md="60" />
      <div style={{ display: 'flex', justifyContent: 'center'}}>
        <div style={{ backgroundColor: 'rgba(79, 71, 71, 0.1)', padding: '2rem', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
          <img style={{ height: '150px'}} src="https://res.cloudinary.com/dam8havko/image/upload/v1713329245/Group_6_yr8w4j.svg" alt="Digitalbyte Login" />
          <h2 style={{ textAlign: 'center', marginTop: '1rem'}} className="cs_section_title cs_fs_20 mb-0">Login</h2>
          {error && (
            <div style={{ color: 'red', textAlign: 'center', marginTop: '1rem', padding: '0.5rem', backgroundColor: 'rgba(255, 0, 0, 0.1)', borderRadius: '4px' }}>
              {error}
            </div>
          )}
          <form style={{ display: 'flex', flexDirection: 'column', width: '400px' }} onSubmit={(e) => submitForm(e)}>
            <label className="cs_fs_12 cs_semibold cs_primary_color">
              Email
            </label>
            <input
              required
              onChange={(e) => setData({...data, email: e.target.value})}
              value={data.email}
              placeholder="Type your email"
              type="email"
              className="cs_form_field"
            />
            <div className="cs_height_38 cs_height_lg_25" />
            <label className="cs_fs_12 cs_semibold cs_primary_color">
              Password
            </label>
            <input
              required
              onChange={(e) => setData({...data, password: e.target.value})}
              value={data.password}
              placeholder="Type your password"
              type="password"
              className="cs_form_field"
            />
            <div className="cs_height_14 cs_height_lg_25" />
            <label style={{ display: 'flex', justifyContent: 'center'}}>
              <input style={{ marginRight: '.25rem' }} type="checkbox" checked={isChecked} onChange={() => setIsChecked(!isChecked)} />
              Stay logged in?
            </label>
            <div className="cs_height_14 cs_height_lg_25" />
            <button type="submit" className="cs_btn cs_style_1" disabled={loading}>
              {loading ? 'Logging in...' : 'Login'}
            </button>
            <p style={{ textAlign: 'center', marginTop: '1rem' }}>Don't have an account? Register <NavLink to="/register" style={{ color: '#5625D8'}}>here</NavLink>!</p>
          </form>
        </div>
      </div>
      <Spacing lg="70" md="70" />
      <Spacing lg="140" md="80" />
      <Spacing lg="75" md="60" />
    </>
  );
}
